import { useQuery } from "react-query";
import { getReportingInstallsBinned } from "../api/install";

export const useReportingInstallsBinned = (entityKey: string) => {
  return useQuery(["entity", entityKey, "installs", "reportingBinned"], () => {
    return getReportingInstallsBinned(entityKey);
  });
};
